// extracted by mini-css-extract-plugin
export default {"techFlipGrid":"TechRow_techFlipGrid__1DAkY"};